<template>
  <div>
    <h3>Edit Translational Team</h3>
    <team-form @save-team="editTeam" :translationalTeam="translationalTeam"></team-form>
  </div>
</template>

<script>
import TeamForm from "../../components/translationalteams/team-form";
import translationalTeamsApi from "../../api/translationalTeams";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";

export default {
  data() {
    return {
      translationalTeam: null
    };
  },

  props: {
    translationalTeamId: {
      required: true
    }
  },

  components: {
    "team-form": TeamForm
  },

  methods: {
    editTeam: function(translationalTeam) {
      var that = this;
      translationalTeam.translationalTeamId = this.translationalTeamId;

      translationalTeamsApi
        .postEditTranslationalTeam(translationalTeam)
        .then(function(response) {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success("The translational team has been saved.", "Success");

          // redirect
          that.$router.push({
            name: "translationalTeam",
            params: { translationalTeamId: response.data }
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },

  created() {
    var that = this;
    translationalTeamsApi
      .getTranslationalTeam(this.translationalTeamId)
      .then(function(response) {
        that.translationalTeam = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>
